/* Core & libraries */
import React, { useState } from "react";
import { useTheme } from "react-jss";
import Col from 'react-bootstrap/Col';
import Alert from 'react-bootstrap/Alert';

/* Helpers, constants, custom methods, internal libraries */
/* Components */

/* Styles */
import styles from "./styles.js"


const AlertMessage = ({content, dismissible, onDismiss, alertStyling}) => {
  const theme = useTheme();
  const classes = styles({ theme });

  return (
    <>
      <div className={classes.alert}>
        <Alert className={`${classes.inside} ${alertStyling || ''}`} variant="danger" onClose={onDismiss} dismissible={dismissible}>
          { content }
        </Alert>
      </div>
    </>
  )
}

export default AlertMessage;
